import React, { useEffect, useState } from "react";
import AllergyDetails from "./AllergyDetails";
import ChronicCondition from "./ChronicCondition";
import FamilyHistory from "./FamilyHistory";
import Vitals from "./Vitals";
import HealthTrends from "./HealthTrends";
import SocialHistory from "./SocialHistory";
import PastMedicalHistory from "./PastMedicalHistory";
import SurgicalHistory from "./SurgicalHistory";
import Medication from "./Medication";
import Immunization from "./Immunization";
import EmergencyCard from "./EmergencyCard";
import { useLocation, useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import MyReports from "../MedicalRecords/MyReports";
import Reports from "./Reports";
import Prescription from "./Prescription";
import LabReport from "./LabReport";
import UploadReport from "./UploadReport";

function HealthSummary() {
  const loggedUserJson = localStorage.getItem("patientData");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;
  const { state } = useLocation();
  const [selectedPatient, setSelectedPatient] = useState(null);
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("Medical History");

  useEffect(() => {
    if (!state) {
      navigate(APP_ROUTES.LOGIN);
    } else {
      setSelectedPatient(state?.patientId);
    }
  }, [state]);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    if (option == "Medical History") {
    }
  };

  const handleBack = () => {
    if (state?.path) {
      navigate(state?.path);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="w-full overflow-y-scroll h-screen bg-cover bg-center bg-fixed bg-blue-50">
      <div className="bg-secondaryColor mb-2">
        <div className="flex justify-between p-3">
          <h2 className="font-bold text-xl text-white">Health Summary</h2>
          {loggedUser && (
            <h2
              className="font-bold text-xl cursor-pointer text-white"
              onClick={handleBack}
            >
              {`<- Back`}
            </h2>
          )}
        </div>
      </div>
      <div className="lg:w-[100%] xl:w-[50%] w-full lg:m-auto m-0 xl:m-auto flex justify-center items-center cursor-pointer rounded-full bg-white">
        <div
          className={`rounded-full md:px-8 px-4 py-3  font-bold text-base md:text-base text-xs ${
            selectedOption == "Medical History"
              ? "bg-secondaryColor text-white"
              : "text-gray-600"
          }`}
          onClick={() => handleOptionChange("Medical History")}
        >
          Medical History
        </div>
        <div
          className={`rounded-full md:px-8 px-4 py-3  font-bold text-base md:text-base text-sm ${
            selectedOption == "Prescription"
              ? "bg-secondaryColor text-white"
              : "text-gray-600"
          }`}
          onClick={() => handleOptionChange("Prescription")}
        >
          Prescription
        </div>
        <div
          className={`rounded-full md:px-8 px-4 py-3  font-bold text-base md:text-base text-sm ${
            selectedOption == "Report"
              ? "bg-secondaryColor text-white"
              : "text-gray-600"
          }`}
          onClick={() => handleOptionChange("Report")}
        >
          Uploaded Report
        </div>
      </div>
      <div className="w-[95%] m-auto mt-5">
        {selectedOption === "Medical History" && selectedPatient && (
          <div className="grid grid-cols-4 sm:grid-cols-1 md:grid-cols-2 border rounded-lg gap-4 bg-blue-100">
            <AllergyDetails selectedPatient={selectedPatient} />
            <PastMedicalHistory selectedPatient={selectedPatient} />
            <Immunization selectedPatient={selectedPatient} />
            <FamilyHistory selectedPatient={selectedPatient} />
            <SocialHistory selectedPatient={selectedPatient} />
            <Medication selectedPatient={selectedPatient} />
            <SurgicalHistory selectedPatient={selectedPatient} />
            <ChronicCondition selectedPatient={selectedPatient} />
            <Vitals selectedPatient={selectedPatient} />
            <HealthTrends selectedPatient={selectedPatient} />
            <EmergencyCard selectedPatient={selectedPatient} />
          </div>
        )}
        {selectedOption === "Prescription" && selectedPatient && (
          <div className="grid border rounded-lg">
            <Prescription selectedPatient={selectedPatient} />
          </div>
        )}
        {selectedOption === "Report" && selectedPatient && (
          <div className="grid border rounded-lg">
            <UploadReport selectedPatient={selectedPatient} />
          </div>
        )}
      </div>
    </div>
  );
}

export default HealthSummary;
